import { render, staticRenderFns } from "./OnBehalfInfo.vue?vue&type=template&id=c44f72bc&scoped=true"
import script from "./OnBehalfInfo.vue?vue&type=script&lang=js"
export * from "./OnBehalfInfo.vue?vue&type=script&lang=js"
import style0 from "./OnBehalfInfo.vue?vue&type=style&index=0&id=c44f72bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44f72bc",
  null
  
)

export default component.exports